import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDisciplineCountry extends TitleBase {
	private disciplineValue: string;
	private countryValue: string;

	protected canHandle(): boolean {
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);

		return (
			this.indexableFilters.length >= 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			!this.multiValueFilters.some((_) => _.type === ParameterType.AREA)
		);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in ${this.disciplineValue} in ${this.countryValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(
			`${this.titlePortalType} in the field of ${this.disciplineValue}`,
			` in ${this.countryValue}`
		);
	}
}
